module.exports = "h3 {\r\n  margin: 0 0 20px;\r\n  line-height: 1;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/refund-form/refund-form.component.css
// module id = ./src/app/shared/components/refund-form/refund-form.component.css
// module chunks = main